import { render } from "./DRecordResize.vue?vue&type=template&id=362402ff&scoped=true"
import script from "./DRecordResize.vue?vue&type=script&lang=js"
export * from "./DRecordResize.vue?vue&type=script&lang=js"

import "./DRecordResize.vue?vue&type=style&index=0&id=362402ff&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-362402ff"]])

export default __exports__